import { combineReducers, configureStore, Reducer } from '@reduxjs/toolkit';
import sessionSlice, { sessionThunks } from './session';
import countriesSlice from '../countries/countriesSlice';
import { timezoneSlice } from '../common/timezone';
import featureFlagHealthcheckSlice from '../featureFlagHealthcheck/featureFlagHealthcheckSlice';
import {
  setDispatchForAxios,
  setSessionThunksForAxios,
} from '../network/apiClient';
import ordersSlice from './ordersTable/ordersSlice';

const rootReducer: Reducer = combineReducers({
  session: sessionSlice.reducer,
  countries: countriesSlice.reducer,
  timezone: timezoneSlice.reducer,
  featureFlag: featureFlagHealthcheckSlice.reducer,
  orders: ordersSlice.reducer,
});

const createStore = () =>
  configureStore({
    reducer: rootReducer,
  });

export const store = createStore();

export type RootState = ReturnType<typeof rootReducer>;

export const connectStoreToNetwork = (): void => {
  setDispatchForAxios(store.dispatch);
  setSessionThunksForAxios(sessionThunks);
};

export default rootReducer;
